<template>

    <div>
        <v-app>
            <v-toolbar flat color="white">
                <v-toolbar-title class="congatec-gray">Role administration</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-text-field id="role_search_bar"
                              v-model="search"
                              class="searchbar"
                              append-icon="search"
                              label="Search"
                              single-line
                              hide-details></v-text-field>

                <v-btn id="create_role_button" class="text-none" v-if="createRole" color="success"
                       @click.stop="onCreateRole()"><span
                        class="text-xs-left">Create role</span>
                </v-btn>

                <router-link to="/rights" v-if="readRight">
                    <v-btn id="navigate_to_rights_page_button" class="text-none">Manage rights</v-btn>
                </router-link>


                <ShowRoleModal v-model="showRoleModal" :role="role" :editMode="editMode" :disabled="disabled"
                               :roleAppRightEntries="roleAppRights" :rolePoolGroupRightEntries="rolePoolGroupRights"/>
                <ConfirmRoleDeletionModal v-model="showDeletionModal" :role="role"/>


                <AssignRightsToRoleModal v-model="showRoleRightAssignmentModal" :role="role" :editMode="editMode"
                                         :disabled="disabled" :roleAppRightEntries="roleAppRights"
                                         :rolePoolGroupRightEntries="rolePoolGroupRights"/>
            </v-toolbar>

            <v-divider></v-divider>


            <v-toolbar flat color="white" v-if="error">
                <v-spacer></v-spacer>

                <v-alert :value="error" type="error" transition="scale-transition">
                    {{ errorMessage }}

                    <v-btn small flat icon color="white" @click="closeAlert">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>

                </v-alert>

            </v-toolbar>

            <v-card flat>
                <v-data-table :headers="headers"
                              :items="roles"
                              :search="search"
                              :expand="expand"
                              item-key="name"
                              hide-actions>
                    <template slot="items" slot-scope="props">
                        <tr @click="props.expanded = !props.expanded">
                            <td class="text-xs-left width-role-name">{{ props.item.name }}</td>
                            <td class="text-xs-left width-role-description">{{ props.item.description }}</td>
                            <td class="text-xs-left">{{ props.item.hierarchy }}</td>
                            <td class="text-xs-left">
                                <v-btn :id="'edit_role_button_' + props.index" color="green" dark small
                                       @click.native.stop="onEditRole(props.item)">
                                    <v-icon v-if="isUpdateEnabled(props.item)" class="mr-2">edit</v-icon>
                                    <v-icon v-else class="mr-2">far fa-eye</v-icon>
                                </v-btn>

                                <v-btn :id="'assign_role_button_' + props.index" dark small
                                       @click.native.stop="onAssignRightToRole(props.item)">
                                    <v-icon class="mr-2">fa-link</v-icon>
                                </v-btn>

                                <v-btn :id="'delete_role_button_' + props.index" color="red" dark small
                                       @click.native.stop="onDeleteRole(props.item)"
                                       v-if="isDeleteEnabled(props.item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>

                    <template slot="expand" slot-scope="props" style="background-color: #DCDCDC">
                        <v-data-table hide-actions hide-headers :items="getUsersForRole(props.item)" :sortable="false"
                                      :headers="expandHeaders">
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td class="text-sm-left width-role-name"
                                        style="background-color: #DCDCDC; font-weight: bold;" v-if="props.index === 0">
                                        Users assigned to role:
                                    </td>
                                    <td v-else class="width-role-name"
                                        style="background-color: #DCDCDC;"></td>

                                    <td class="width-role-description text-xs-left"
                                        style="background-color: #DCDCDC; font-weight: bold;">{{ props.item
                                        }}
                                    </td>
                                    <td class="width-lastName"/>
                                    <td class="width-isActive"/>
                                    <td class="width-options"/>
                                </tr>
                            </template>
                            <template slot="no-data">
                                <tr>
                                    <td class="text-xs-left"
                                        style="width: 60%; background-color: #DCDCDC; font-weight: bold">No user
                                        assigned to role.
                                    </td>
                                    <td class="text-xs-center" style="width: 40%;"></td>
                                </tr>

                            </template>
                        </v-data-table>
                    </template>

                </v-data-table>
            </v-card>
        </v-app>


    </div>

</template>


<script>

    import ShowRoleModal from './modals/ShowRoleModal.vue';
    import ConfirmRoleDeletionModal from './modals/ConfirmRoleDeletionModal';
    import AssignRightsToRoleModal from './modals/AssignRightsToRoleModal';
    import roleinterface from "../../../interfaces/roleinterface";
    import {EventBus} from "../../../eventbus";
    import rolerightmanager from "../../../managers/rolerightmanager";
    import userroleinterface from "../../../interfaces/userroleinterface";

    export default {
        name: "RoleList",

        components: {
            ShowRoleModal,
            ConfirmRoleDeletionModal,
            AssignRightsToRoleModal
        },

        data: () => ({
            search: "",

            expand: false,

            pagination: {
                sortBy: 'hierarchy'
            },

            headers: [
                {text: 'Name', value: 'name'},
                {text: 'Description', value: 'description'},
                {text: 'Hierarchy', value: 'hierarchy'},
                {text: 'Options', value: 'options'}
            ],

            roles: [],
            userRoles: [],

            role: {
                roleId: null,
                name: null,
                description: null,
                isEditDisabled: false,
                hierarchy: 0,
                roleAppRights: null,
                rolePoolGroupRights: null
            },

            emptyRole: {
                roleId: null,
                name: null,
                description: null,
                isEditDisabled: false,
                hierarchy: 0,
                roleAppRights: null,
                rolePoolGroupRights: null
            },

            createRole: false,
            deleteRole: false,
            updateRole: false,
            readRight: false,

            error: false,
            errorMessage: null,

            showDeletionModal: false,
            showRoleModal: false,
            showRoleRightAssignmentModal: false,
            editMode: false,
            disabled: false,
            roleAppRights: [],
            rolePoolGroupRights: []
        }),

        created() {
            this.initialize();
            this.initializeRights();
        },

        mounted() {
            EventBus.$on('refreshRoleList', () => {
                this.initialize();
            });
            EventBus.$on('roleDeletionConfirmed', () => {
                this.initialize();
                this.role = Object.assign({}, this.emptyRole);
                this.editMode = false;
            });
            EventBus.$on('roleDeletionClosed', () => {
                this.initialize();
                this.role = Object.assign({}, this.emptyRole)
            });
            EventBus.$on('roleModalClosed', () => {
                this.initialize();
                this.role = Object.assign({}, this.emptyRole);
                this.roleAppRights = [];
                this.rolePoolGroupRights = [];
            });
        },

        methods: {

            onCreateRole() {
                this.disabled = false;
                this.editMode = false;
                this.role = Object.assign({}, this.emptyRole);

                this.showRoleModal = true;
            },

            async onEditRole(role) {
                let clonedRole = {
                    roleId: role.roleId,
                    name: role.name,
                    isEditDisabled: role.isEditDisabled,
                    description: role.description,
                    hierarchy: role.hierarchy,
                    roleAppRights: role.roleAppRights,
                    rolePoolGroupRights: role.rolePoolGroupRights
                };

                await rolerightmanager.getRoleAppRights(clonedRole, roleAppRights => {
                    this.roleAppRights = roleAppRights;
                });

                await rolerightmanager.getRolePoolGroupRights(clonedRole, poolGroupRights => {
                    this.rolePoolGroupRights = poolGroupRights;
                });

                this.role = Object.assign({}, clonedRole);

                this.disabled = role.isEditDisabled ? role.isEditDisabled : !this.updateRole;
                this.editMode = true;

                this.showRoleModal = true;
            },

            async onAssignRightToRole(role) {
                let clonedRole = {
                    roleId: role.roleId,
                    name: role.name,
                    description: role.description,
                    isEditDisabled: role.isEditDisabled,
                    hierarchy: role.hierarchy,
                    roleAppRights: role.roleAppRights,
                    rolePoolGroupRights: role.rolePoolGroupRights
                };

                await rolerightmanager.getRoleAppRights(clonedRole, roleAppRights => {
                    this.roleAppRights = roleAppRights;
                });

                await rolerightmanager.getRolePoolGroupRights(clonedRole, poolGroupRights => {
                    this.rolePoolGroupRights = poolGroupRights;
                });

                this.role = Object.assign({}, clonedRole);
                this.disabled = role.isEditDisabled ? role.isEditDisabled : !this.updateRole;
                this.editMode = true;

                this.showRoleRightAssignmentModal = true;
            },

            async onDeleteRole(role) {
                this.role = Object.assign({}, role);
                this.showDeletionModal = true;
            },

            initialize() {
                roleinterface.getRoles(roles => {
                    this.roles = roles;
                });
                userroleinterface.getUserRoles(userRoles => {
                    this.userRoles = userRoles;
                });
            },

            initializeRights() {
                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "RoleCreate") {
                        this.createRole = true;
                    }

                    if (right.right === "RoleDelete") {
                        this.deleteRole = true;
                    }

                    if (right.right === "RoleUpdate") {
                        this.updateRole = true;
                    }

                    if (right.right === "RightRead") {
                        this.readRight = true;
                    }
                });
            },

            closeAlert() {
                this.error = false;
                this.errorMessage = null;
            },

            getUsersForRole(role) {
                let users = [];

                if (this.userRoles != null) {
                    this.userRoles.forEach(userRole => {
                        if (userRole.role != null && userRole.user != null && role != null && userRole.role.roleId === role.roleId) {
                            users.push(userRole.user.userName);
                        }
                    })
                }

                return users.length > 0 ? users : [];
            },

            isDeleteEnabled(role) {
                return role.isEditDisabled ? !role.isEditDisabled : this.deleteRole;
            },

            isUpdateEnabled(role) {
                return role.isEditDisabled ? !role.isEditDisabled : this.updateRole;
            }
        }
    };


</script>

<style>
    .width-role-name {
        width: 30%
    }

    .width-role-description {
        width: 30%
    }
</style>


// WEBPACK FOOTER //
// src/components/common/roles/RoleList.vue